import { useAccordion } from '../../../customHook.js/useAccordion'
import useScrollAnimation from '../../../customHook.js/useScrollAnimation'

import RenderContent from '../../../helpers/RenderContent'
import { highlightText } from '../../../helpers/helperFunctions'
import { allAround1 } from '../../../const/contentData'

import modelRTL from '../../../const/modelRTL'
import hi from '../../../images/hi.jpg'
import parking from '../../../images/parking.svg'
import classes from '../content.module.css'

function AllAround({ searchTerm }) {
  const moduleName = 'allAround'

  const { selectedRow, highlightedText, changeSelectedRow } = useAccordion(
    moduleName,
    searchTerm,
    0
  )

  const getToContainer = useScrollAnimation(moduleName)

  return (
    <div
      className={`${classes.main_container} ${
        !modelRTL[moduleName] && 'row_reverse'
      }`}
      id={moduleName}
    >
      <div
        className={`${classes.text_area} ${
          modelRTL[moduleName] ? classes.hidden_left : classes.hidden_right
        } ${getToContainer && classes.visible}`}
        dir="rtl"
      >
        <div className={classes.drop_down_section}>
          <div className="c_blue">
            <img className={classes.section_img} src={parking} alt="parking" />
          </div>
          <div>
            {allAround1.map(({ id, title, content, uniqueId }) => (
              <div key={id} id={uniqueId}>
                <div
                  className={`${classes.drop_down_title}  ${
                    selectedRow === id && classes.drop_down_open
                  } c_pink`}
                  onClick={() => changeSelectedRow(id)}
                >
                  <div className={classes.toggle_icon_container}>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow !== id && classes.visible
                      }`}
                    >
                      +
                    </span>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow === id && classes.visible
                      }`}
                    >
                      -
                    </span>
                  </div>
                  {highlightText(title, highlightedText)}
                </div>
                <div
                  className={`${classes.text_container} ${
                    selectedRow === id && classes.show
                  }`}
                >
                  <RenderContent
                    content={content}
                    searchTerm={highlightedText}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className={`${classes.main_img_container} ${
          modelRTL[moduleName] ? classes.hidden_right : classes.hidden_left
        }  ${getToContainer && classes.visible}`}
        dir="rtl"
      >
        <img src={hi} alt="hi" />
        <div>
          <h2>NICE</h2>
          <h2>Everyday</h2>
        </div>
      </div>
    </div>
  )
}

export default AllAround
